export const client = {
    id: 1,
    externalId: '1',
    name: 'Company',
    language: 'en',
    geocodingLanguages: ['bg', 'cs', 'de', 'ee', 'en', 'es', 'et', 'fr', 'lv', 'pl', 'pt', 'sk']
};
